/**
 * gtag.js 客户端加载
 *
 * 等价于在 <head> 里贴:
 *   <script async src="https://www.googletagmanager.com/gtag/js?id=G-XXXX"></script>
 *   <script>...gtag('config', 'G-XXXX')...</script>
 *
 * 在 main.js 调一次 initGA4() 即可
 * Vue 2 SPA 没有 SSR 概念,直接 import 跑
 *
 * 必须用 hostname 不是 host —— host 带端口(localhost:8080),
 * 会让本地开发匹配不上 'localhost' 配置,fallback 到生产配置,
 * 事件就被打到正式 GA4 资源了
 */
import { getGA4Config } from './ga4-config'

export function initGA4() {
  if (typeof window === 'undefined') return

  const measurementId = getGA4Config().measurementId
  if (!measurementId) {
    console.warn('[ga4] measurement id not configured')
    return
  }

  // 初始化 dataLayer + gtag 队列(标准实现,跟 Google 文档一字不差)
  window.dataLayer = window.dataLayer || []
  // gtag 客户端插件只装了 stub(把调用塞 dataLayer),真 gtag.js 从 googletagmanager 异步加载
  function gtag() {
    window.dataLayer.push(arguments)
  }
  window.gtag = gtag
  gtag('js', new Date())
  gtag('config', measurementId)

  // 异步加载 gtag.js
  var script = document.createElement('script')
  script.async = true
  script.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(measurementId)
  document.head.appendChild(script)
}
